import mergeModuleConfigs from 'core/utils/mergeModuleConfigs';
import { flyoutCategories as orgConfig } from 'org/configs/modules.config';
import { FLYOUT_CATEGORIES_GET_SUCCESS, FLYOUT_CATEGORIES_GET_FAILURE } from '../actions/types';

/** @type {object} */
const defaultConfig = {
  defaults: {
    api: {
      params: {},
      options: {
        success: FLYOUT_CATEGORIES_GET_SUCCESS,
        failure: FLYOUT_CATEGORIES_GET_FAILURE,
        cache: { isEnabled: true, isPublishedData: true },
      },
    },
  },
};

export default mergeModuleConfigs(defaultConfig, orgConfig);
